import { Component, OnInit, Input, Output, EventEmitter,ElementRef, ViewChild, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from "../../api/index";
import { SnackService } from "../../services/index";

import { FullCalendarComponent , CalendarOptions  } from '@fullcalendar/angular';
import dayGridPlugin from '@fullcalendar/daygrid';


@Component({
  selector: 'school-full-calendar',
  templateUrl: './full-calendar.component.html',
  styleUrls: ['./full-calendar.component.scss']
})
export class FullCalendarUIComponent implements OnInit, OnDestroy {
  options: any;
  eventsModel: any;
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;

  calendarOptions: CalendarOptions = {
    initialView: 'dayGridMonth',
    events: [
      { title: 'event 1', date: '2021-01-01' },
      { title: 'event 2', date: '2021-01-02' }
    ]
  };

  ngOnInit() {
   this.calendarOptions
  }

  handleDateClick(arg) {
    alert('date click! ' + arg.dateStr)
  }


  constructor(private route: Router,
    private _userService: CommonService,
    private _snackService: SnackService,
  ) { }


  ngOnChanges(): void{
    // onchanges
  }
  
  ngOnDestroy(): void {
    // ngdestroy
  }

}
